<template>
	<v-btn
		:type="type"
		:disabled="disabled"
		:outlined="outlined"
		:class="[textTransform]"
		depressed
		color="primary"
		min-width="100"
		@click="$emit('salvar')"
	>
		{{ label }}
	</v-btn>
</template>

<script>
export default {
	name: 'botao-salvar',
	props: {
		disabled: {
			type: Boolean,
		},
		outlined: {
			type: Boolean,
		},
		label: {
			type: String,
			default: 'Salvar',
		},
		type: {
			type: String,
			default: 'submit',
		},
		textTransform: {
			type: String,
			default: 'cp-text-inherit',
		},
	},
}
</script>
